import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M5.186 14.624s-.423-4.158 5.367-8.461c5.79-4.304 11.368-2.966 11.368-2.966s1.477 6.455-3.498 11.34c-2.322 2.268-4.342 3.373-5.82 3.868-1.749.61-3.739.058-4.824-1.396-.392-.524-.543-1.076-.151-1.512 1.116-1.222 4.613 2.268-2.11 2.413"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="m11.518 18.783.03 2.791c0 .32.332.524.633.378 1.297-.581 4.162-1.948 4.403-2.646.301-.93-.181-2.908-.181-2.908M5.336 13.258l-2.894-.03c-.332 0-.543-.32-.392-.61.603-1.25 2.02-4.013 2.744-4.245.964-.291 3.015.174 3.015.174"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M6.362 10.815s5.82.495 7.387 7.008"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M18.423 14.537c-2.322 2.268-4.342 3.373-5.82 3.868-1.748.61-3.739.058-4.824-1.396-.392-.524-.543-1.076-.15-1.512 1.115-1.222 4.613 2.268-2.112 2.413"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const RocketIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
